var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPluss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.167 1.83464C11.167 1.1903 10.6447 0.667969 10.0003 0.667969C9.35599 0.667969 8.83366 1.1903 8.83366 1.83464V8.83453L1.83366 8.83453C1.18933 8.83453 0.666992 9.35686 0.666992 10.0012C0.666992 10.6455 1.18933 11.1679 1.83366 11.1679L8.83366 11.1679V18.168C8.83366 18.8123 9.35599 19.3346 10.0003 19.3346C10.6447 19.3346 11.167 18.8123 11.167 18.168V11.1679L18.167 11.1679C18.8113 11.1679 19.3337 10.6455 19.3337 10.0012C19.3337 9.35686 18.8113 8.83453 18.167 8.83453L11.167 8.83453V1.83464Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluss);
export default __webpack_public_path__ + "static/media/Pluss.7bfa26f3f6bb85476f1968e9d4237fb8.svg";
export { ForwardRef as ReactComponent };